module.exports = __webpack_public_path__ + "static/media/igw-l-menu.63190e78.svg";